import notificationSoundUrl from '../assets/notification.wav';

let orderAlertAudio = null;

/** Play order-alert sound when a WebSocket ORDER event is shown. Autoplay blocks are ignored. */
export function playOrderAlertSound() {
  try {
    if (typeof Audio === 'undefined') return;
    if (!orderAlertAudio) {
      orderAlertAudio = new Audio(notificationSoundUrl);
    }
    orderAlertAudio.currentTime = 0;
    const playPromise = orderAlertAudio.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  } catch {
    // Browser autoplay or missing Audio support — alert UI still shows.
  }
}
